import { CartProductWithQuantities, SupplierOrderData } from '../../../utils/types/Cart'

interface CartItemsModalModel {
  onClose: () => void
  isOnMobile: boolean
  recentlyAddedProducts: CartProductWithQuantities[] | undefined
  hasLowerMovBrand: boolean
  supplierOrderData: SupplierOrderData[]
}

class CartItemsModal implements CartItemsModalModel {
  onClose: CartItemsModalModel['onClose']

  isOnMobile: CartItemsModalModel['isOnMobile']

  recentlyAddedProducts: CartItemsModalModel['recentlyAddedProducts']

  hasLowerMovBrand: CartItemsModalModel['hasLowerMovBrand']

  supplierOrderData: CartItemsModalModel['supplierOrderData']

  constructor(
    {
      onClose,
      isOnMobile,
      recentlyAddedProducts,
      hasLowerMovBrand,
      supplierOrderData,
    }: CartItemsModalModel,
  ) {
    this.onClose = onClose
    this.isOnMobile = isOnMobile
    this.recentlyAddedProducts = recentlyAddedProducts
    this.hasLowerMovBrand = hasLowerMovBrand
    this.supplierOrderData = supplierOrderData
  }
}

export default CartItemsModal
